import { useEffect } from 'react';

import { LOCAL_STORAGE } from '../constants/local-storage';
import { showOnStand, StandEnum } from '../utils/show-on-stand';

export const useFingerprint = () => {
  useEffect(() => {
    const isApprovedScreenShown = localStorage.getItem(LOCAL_STORAGE.isApprovedScreenShown);
    const isNewClient = sessionStorage.getItem(LOCAL_STORAGE.isNewClient);
    const isNewApp = sessionStorage.getItem(LOCAL_STORAGE.isNewApp);
    const isDev = showOnStand({ stands: [StandEnum.DEV, StandEnum.LOCAL] });
    const analyticsDev = sessionStorage.getItem(LOCAL_STORAGE.analytics);

    if (!isApprovedScreenShown) {
      localStorage.setItem(LOCAL_STORAGE.isApprovedScreenShown, 'false');
    }
    if (!isNewClient) {
      sessionStorage.setItem(LOCAL_STORAGE.isNewClient, 'true');
    }
    if (!isNewApp) {
      sessionStorage.setItem(LOCAL_STORAGE.isNewApp, 'true');
    }
    if (isDev && !analyticsDev) {
      sessionStorage.setItem(LOCAL_STORAGE.analytics, 'false');
    }
  }, []);
};
